import { OmitSubobject } from "@/types/UtilityTypes";
import { Box, Tooltip, TooltipProps } from "@mui/material";
import { ISelectProps, Select } from "@ngt/opms";
import { FC, PropsWithChildren } from "react";

interface ISelectWithTooltipProps extends ISelectProps {
    tooltipProps: OmitSubobject<TooltipProps, PropsWithChildren>;
}

const SelectWithTooltip: FC<ISelectWithTooltipProps> = ({
    tooltipProps,
    ...rest
}) => {
    return (
        <Tooltip
            {...tooltipProps}
        >
            <Box width="100%">
                <Select 
                    {...rest}
                    fullWidth
                />
            </Box>
        </Tooltip>
    );
}

export default SelectWithTooltip